import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'success' | 'warning' | 'danger' | 'info';
  className?: string;
}

export const Badge = ({ 
  children, 
  variant = 'default',
  className = '' 
}: BadgeProps) => {
  const variants = {
    default: "bg-brand/10 text-brand border-brand/20",
    success: "bg-accent-success/10 text-accent-success border-accent-success/20",
    warning: "bg-accent-warning/10 text-accent-warning border-accent-warning/20",
    danger: "bg-accent-danger/10 text-accent-danger border-accent-danger/20",
    info: "bg-brand/10 text-brand border-brand/20",
  };

  return (
    <span 
      className={`
        inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium
        ${variants[variant]} 
        ${className}
      `}
    >
      {children}
    </span>
  );
};
